const ActionTypes = {
  GET_APPOINTMENTS: 'GET_APPOINTMENTS',
  GET_LEGAL_STATEMENT: 'GET_LEGAL_STATEMENT',
  GET_SUBMISSION_STATUS: 'GET_SUBMISSION_STATUS',
  VALIDATE_POSTCODE: 'VALIDATE_POSTCODE',
  VALIDATE_PHONE_NUMBER: 'VALIDATE_PHONE_NUMBER',
  GET_AUTOCOMPLETE_OPTIONS: 'GET_AUTOCOMPLETE_OPTIONS',
  GET_EXTERNAL_SELECT_OPTIONS: 'GET_EXTERNAL_SELECT_OPTIONS',
  GET_CUSTOMER_MATCHES: 'GET_CUSTOMER_MATCHES',
  PREPARE_SUPPLIER_MATCHING: 'PREPARE_SUPPLIER_MATCHING',
  GET_SUPPLIER_CARD_LOGOS: 'GET_SUPPLIER_CARD_LOGOS',
  DECRYPT_CRM_DATA: 'DECRYPT_CRM_DATA',
  SUBSCRIBE_TO_NEWSLETTER: 'SUBSCRIBE_TO_NEWSLETTER',
  IS_DOMAIN_INTERNAL: 'IS_DOMAIN_INTERNAL',
  GET_DYNAMIC_NEWSLETTER: 'GET_DYNAMIC_NEWSLETTER',
  HANDLE_ANSWER_QUESTION_SIDE_EFFECTS: 'HANDLE_ANSWER_QUESTION_SIDE_EFFECTS',
  HANDLE_ANSWER_QUESTION_SIDE_EFFECTS_COMPLETED:
    'HANDLE_ANSWER_QUESTION_SIDE_EFFECTS_COMPLETED',
  SUBMIT_SELECT_AND_CONNECT: 'SUBMIT_SELECT_AND_CONNECT',
};

export default ActionTypes;
